class TapstitchSizeChart extends HTMLElement {
  constructor() {
    super();
    this.unit = "cm"; // default
  }

  connectedCallback() {
    try {
      this.tableHead = this.querySelector("thead");
      this.tableBody = this.querySelector("tbody");
      this.toggles = this.querySelectorAll(".size-chart-toggle");

      if (!this.tableHead || !this.tableBody) return;

      this.parseRawData();
      this.render();

      this.toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          this.toggles.forEach((t) => t.classList.remove("active"));
          e.target.classList.add("active");
          this.unit = e.target.dataset.unit;
          this.render();
        });
      });
    } catch (error) {
      if (this.tableBody) {
        this.tableBody.innerHTML = `<tr><td colspan="10" style="color: red;">Error rendering size chart: ${error.message}</td></tr>`;
      }
      console.error("TapstitchSizeChart Error:", error);
    }
  }

  parseRawData() {
    const template = this.querySelector("template[data-raw-html]");
    if (!template) throw new Error("Template data-raw-html not found");

    // Use template.content for robustness
    let table = template.content.querySelector("table");

    // Fallback if template.content isn't populated for some reason
    if (!table) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(template.innerHTML, "text/html");
      table = doc.querySelector("table");
    }

    if (!table) throw new Error("Table not found inside template");

    const rows = Array.from(table.querySelectorAll("tr"));
    if (rows.length < 3)
      throw new Error("Not enough rows in source table (expected at least 3)");

    // Row 0: Sizes (e.g. ['', 'S', 'M', 'L', 'XL'])
    const sizeCells = Array.from(rows[0].querySelectorAll("td, th")).filter(
      (cell) => cell.textContent.trim() !== "",
    );
    this.sizes = sizeCells.map((cell) => cell.textContent.trim());

    if (this.sizes.length === 0)
      throw new Error("No sizes found in the first row");

    // Row 2+ are the attributes (Chest, Length, etc.)
    this.chartMeasurements = [];
    this.data = {};

    this.sizes.forEach((size) => {
      this.data[size] = { cm: {}, in: {} };
    });

    for (let i = 2; i < rows.length; i++) {
      const cells = Array.from(rows[i].querySelectorAll("td, th"));
      if (cells.length < 1) continue;

      const attrName = cells[0].textContent.trim();
      if (!attrName) continue; // Skip empty rows

      this.chartMeasurements.push(attrName);

      let cellIndex = 1;
      for (let s = 0; s < this.sizes.length; s++) {
        const size = this.sizes[s];
        if (cellIndex < cells.length) {
          this.data[size]["in"][attrName] = cells[cellIndex].textContent
            .trim()
            .replace(/\u00A0/g, " ");
        }
        if (cellIndex + 1 < cells.length) {
          this.data[size]["cm"][attrName] = cells[cellIndex + 1].textContent
            .trim()
            .replace(/\u00A0/g, " ");
        }
        cellIndex += 2;
      }
    }
  }

  render() {
    if (!this.sizes || !this.chartMeasurements) return;

    let theadHtml = "<tr><th>Size</th>";
    this.chartMeasurements.forEach((attr) => {
      theadHtml += `<th>${attr}</th>`;
    });
    theadHtml += "</tr>";
    this.tableHead.innerHTML = theadHtml;

    let tbodyHtml = "";
    this.sizes.forEach((size) => {
      tbodyHtml += `<tr><td><strong>${size}</strong></td>`;
      this.chartMeasurements.forEach((attr) => {
        const val = this.data[size][this.unit][attr] || "-";
        tbodyHtml += `<td>${val}</td>`;
      });
      tbodyHtml += "</tr>";
    });
    this.tableBody.innerHTML = tbodyHtml;
  }
}

if (!customElements.get("tapstitch-size-chart")) {
  customElements.define("tapstitch-size-chart", TapstitchSizeChart);
}
